import React from "react";
import "../css/Testimonials.css";
import DeepakPhoto from "../assets/Deepak.png";
import EfoePhoto from "../assets/Efoe.png";
import MehulPhoto from "../assets/Mehul.png";

function Testimonials() {
  const testimonials = [
    {
      name: "Deepak Mishra",
      quote: "I love the product, but what impressed me most was how the founders personally helped with my RSUs. Even though the platform didn't support them yet, they went the extra mile and manually calculated every tax lot for me. That kind of dedication is rare.",
      photo: DeepakPhoto
    },
    {
      name: "Efoe Adjakly",
      quote: "What I love about ProfiTree is the clarity and confidence it gives me. Seeing the tax impact upfront has helped me avoid costly mistakes and taught me the value of tax-aware investing. Truly a game changer.",
      photo: EfoePhoto
    },
    {
      name: "Mehul Mehta",
      quote: "I was lost on wash sales and tax-loss harvesting, but Akshat took the time to explain it all. Last year I got stuck with a huge capital gains bill, but this year ProfiTree kept me tax-aware and saved me from repeating that mistake.",
      photo: MehulPhoto
    }
  ];

  const base = process.env.PUBLIC_URL + "/logos";
  const companies = [
    { name: "Netflix", logo: `${base}/logo_netflix.svg` },
    { name: "Oracle", logo: `${base}/logo_oracle.svg` },
    { name: "LiveRamp", logo: `${base}/logo_liveramp.png` },
    { name: "Nvidia", logo: `${base}/logo_nvidia.svg` },
    { name: "Google", logo: `${base}/logo_google.svg` },
    { name: "Credit Karma", logo: `${base}/logo_creditkarma.svg` },
    { name: "Amazon", logo: `${base}/logo_amazon.svg` }
  ];

  return (
    <section className="testimonials-section">
      <div className="content-wrapper">
        <div className="testimonials-header">
          <h2>From Our Champions</h2>
          <p>Real stories from investors who've transformed their tax strategy</p>
        </div>
        
        <div className="testimonials-container">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-content">
                <div className="quote-icon">"</div>
                <p className="testimonial-quote">{testimonial.quote}</p>
                <div className="testimonial-author">
                  <div className="author-photo">
                    <img src={testimonial.photo} alt={testimonial.name} />
                  </div>
                  <div className="author-info">
                    <h4>{testimonial.name}</h4>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Trusted by employees section */}
        <div className="trusted-by-section">
          <div className="trusted-by-header">
            <h3>Trusted by employees at leading companies</h3>
          </div>
          <div className="company-logos-wrapper">
            <div className="company-logos-track">
              {/* First set of logos */}
              {companies.map((company, index) => (
                <div key={`first-${index}`} className="company-logo">
                  <img src={company.logo} alt={company.name} />
                </div>
              ))}
              {/* Duplicate set for seamless loop */}
              {companies.map((company, index) => (
                <div key={`second-${index}`} className="company-logo">
                  <img src={company.logo} alt={company.name} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials; 